import { LearningObjectAuthorization } from '@hendrx/core/common/components/pages/Player/Authorization/LearningObjectAuthorization';
import { PlayerLearningActivityPage } from '@hendrx/core/learningActivity/pages/PlayerLearningActivityPage';
import { createFileRoute } from '@tanstack/react-router';

import { PLAYER_MODE_PREVIEW } from 'shared/common/consts/playerSearchParams';

import { createRouteGuard } from '@/app/_lib/guards/createRouteGuard';
import {
  allowFreeContentEmbed,
  anyOf,
  requireAuthenticated,
  requirePreviewModeAllowed
} from '@/app/_lib/guards/primitives';

export const Route = createFileRoute('/player/learning-activity/$learningActivityDraftId')({
  // Anonymous access is allowed only on the embed signal; the server authorizes 720 (and denies OFEK).
  beforeLoad: createRouteGuard(
    anyOf(requireAuthenticated(), allowFreeContentEmbed()),
    requirePreviewModeAllowed({ capability: 'studio.access' })
  ),
  component: RouteComponent
});

function RouteComponent() {
  const { learningActivityDraftId } = Route.useParams();
  const { mode } = Route.useSearch();
  const isPlayerAsPreview = mode === PLAYER_MODE_PREVIEW;
  return (
    <LearningObjectAuthorization learningObjectDraftId={learningActivityDraftId} checkPlenaryRedirect>
      <PlayerLearningActivityPage
        isPlayerAsPreview={isPlayerAsPreview}
        learningActivityDraftId={learningActivityDraftId}
      />
    </LearningObjectAuthorization>
  );
}
